module.exports = __webpack_public_path__ + "img/cbff4d8.png";